import { render, staticRenderFns } from "./UnreadStaffModal.vue?vue&type=template&id=63cfbcb6&"
import script from "./UnreadStaffModal.vue?vue&type=script&lang=js&"
export * from "./UnreadStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports